import { useLang } from "../contexts/LanguageContext";

export default function Footer() {
  /* Inciar constante de traducción */
  const { t } = useLang();
  return (
    <footer className="d-flex flex-wrap justify-content-between align-items-end py-3 bg-body-tertiary">
        <ul className="nav col-12 col-md-6 justify-content-center">
            <li className="nav-item"><a href="/index" className="nav-link px-2 text-body-secondary">{t("FOOTER_INDEX")}</a></li>
            <li className="nav-item"><a href="/privacy" className="nav-link px-2 text-body-secondary">{t("FOOTER_PRIVACY")}</a></li>
            <li className="nav-item"><a href="/terms_of_use" className="nav-link px-2 text-body-secondary">{t("FOOTER_TERMS_OF_USE")}</a></li>
            <li className="nav-item"><a href="/customer_support" className="nav-link px-2 text-body-secondary">{t("FOOTER_CUSTOMER")}</a></li>
            <li className="nav-item"><a href="/help_us" className="nav-link px-2 text-body-secondary">{t("FOOTER_HELP_US")}</a></li>
            <li className="nav-item"><a href="/about_us" className="nav-link px-2 text-body-secondary">{t("FOOTER_ABOUT_US")}</a></li>
        </ul>

        <p className="col-12 col-md-6 mb-0 text-body-secondary text-center">{t("FOOTER_COPYRIGHT")}<br></br>{t("FOOTER_READERUM_TEXT")}</p>      
    </footer>


  );
}
